export const userRoles = {
    employee: "Employee",
    employer: "Employer",
    carrier: "Carrier",
    organisation: "Organisation",
    agent: "Agency",
    admin: "Admin",
    dependent: "Dependent"
};

export const billingPortal = ["billing.clearwaterhealth.com"];

export const amtPasswordFieldTextOne = "Enter your Date of Birth in the format of MMDDYYYY.";
export const amtPasswordFieldTextTwo = "Example: If born on March 5th 1980, please enter 03051980.";

export const loginTitle = "Login";

export const clearwaterERLoginTitle = "Employer / Vendor Login";

export const clearwaterEELoginTitle = "Member Login";

export const employerButtonTitle = "Click Here for Employer / Vendor Login Page";

export const employeeButtonTitle = "Click Here for Member Login Page";

export const vendorLoginTitle = "Vendor Login";

export const vendorButtonTitle = "Click Here for Vendor Login Page";

export const logoSize = { width: 258, height: 78 };

export const headerRowFontStyle = { name: 'Calibri', bold: true };

export const headerRowBackgroundStyle = { type: "pattern", pattern: "solid", fgColor: { argb: "DCE6F1" } };

export const cellBorderStyle = { top: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } } as any;

export const fullCellBorderStyle = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } } as any;

export const accountingNumFmt = '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)';

export const amountColumns = [
    'Employee Contribution',
    'Employer Contribution',
    'Stop Loss Contribution',
    'Reserve Contribution',
    'Administrative Fee Contribution',
    'Total'
];

export const rowDataIndex = 9;

export const downloadFileTypes = {
    'pdf': 'pdf',
    'excel': 'excel'
};

export const groupbillExcelSheet1 = "Invoice Details";

export const groupbillExcelSheet2 = "GroupBill Summary";

export const groupbillExcelSheet3 = "Headcount";

export const groupbillExcelSheet4 = "Amount by Plan Year by Period";

export const billingPaymentType = {
    invoice: 'Invoice',
    individual: 'Individual'
}

export const headerRowIndices = [10, 14]; // Row indices you want to style

export const tableRowIndices = [10, 11, 14, 15]; // Row indices you want to style, the notes row is resolved at runtime

export const colWidth = [20, 20, 18, 15, 15];

export const amountHeaderRow = 14;

export const amountDataRow = 15;

export const notesRowPrefix = 'Notes:';

export const notesRowSpan = 15; // Number of rows the notes cell is merged across

export const columnWidthPadding = 4;

/* IES-5378 : Bill info and overdue aging blocks on the invoice details sheet. */
export const invoiceBlockStartRow = 3;

export const billInfoBlockColumns = ['C', 'D'];

export const agingBlockColumns = ['H', 'I'];

export const agingSummaryRowCount = 3; // Label row, value row and spacer the API appends when overdue aging is enabled

export const billInfoBlockRows = [
    { label: 'Name:', key: 'A' },
    { label: 'Created Date:', key: 'C' },
    { label: 'Due Date:', key: 'D' },
    { label: 'Group Bill No:', key: 'groupBillNo' },
    { label: 'Group Bill Period:', key: 'B' }
];

export const agingBlockRows = [
    { label: 'Current Amount Due:', key: 'currentDue' },
    { label: '31-60 Days Past Due:', key: 'days31To60' },
    { label: '61-90 Days Past Due:', key: 'days61To90' },
    { label: '90+ Days Past Due:', key: 'days90Plus' },
    { label: 'Total Amount Due:', key: 'totalDue' }
];

export const paymentTypes = {
    cc: 'CC',
    ach: 'ACH'
}

export const tobaccoValues = {
    y: 'Y',
    n: 'N'
}

export const SSOLoginRedirectToDashboardConditions = ['', 'change-password', 'check-login'];

export const dependentTypes = {
    self: 'Self',
    spouse: 'Spouse',
    child: 'Child',
    disabledChild: 'Disabled Child'
}

export const ageForDependents = 18;

export const arrowPaginate = {
    first: '<a href="javascript:void(0)" class="text-primary-color dt-pagination-custom">&#171;</a>',
    last: '<a href="javascript:void(0)" class="text-primary-color dt-pagination-custom">&#187;</a>',
    next: '<a href="javascript:void(0)" class="text-primary-color dt-pagination-custom">&#8250;</a>',
    previous: '<a href="javascript:void(0)" class="text-primary-color dt-pagination-custom">&#8249;</a>'
}

export const paymentMethods = {
    cc: 'Credit Card',
    ach: 'ACH Bank Draft'
}

export const hideBackButton = [
    '/dashboard',
]

export const dependentLoginVerfiyRoutes = ['/passcode', '/passcode-verification'];

export const emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const loginEmailPattern = /^\s*(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/;
export const accountTypes = {
    'amt': 'AMT',
    'premeddefender': 'Pre-Med Defender'
}

export const AMTDomains = ['portal.activateamt.com'];

export const presidioDomains = ['portal.presidiocare.com', 'member.presidiocare.com', 'presidio-portal-uat.veridyhealth.com'];

export const publicRoutes = ['/login', '/login/member', '/forgot-password', '/privacy-policy', '/quick-enroll'];

export const passcodeDisabledUserRoles = [userRoles.employer.toLowerCase(), userRoles.carrier.toLowerCase()];
export const fileIcons = {
    pdf: 'assets/theme/images/icons/pdf-icon.png',
    doc: 'assets/theme/images/icons/doc-icon.png',
    image: 'assets/theme/images/icons/jpg-icon.png',
    other: 'assets/theme/images/icons/file-icon.png'
};